import React, { useId } from "react";
import Slider from "react-slick";

function ExperienceArrow({ direction, onClick }) {
  return (
    <button type="button" className={`podcast-slider-next dynamic-team-work-arrow dynamic-team-work-${direction}`} onClick={onClick} aria-label={`View ${direction === "prev" ? "previous" : "next"} experience`}>
      <i className={`fa-solid fa-arrow-${direction === "prev" ? "left" : "right"}`} aria-hidden="true" />
    </button>
  );
}

export default function HowTeamsWorkSection({ data }) {
  const titleId = useId();
  if (!data?.items?.length) return null;

  // Repeat a full set so Slick can loop when all three experiences are visible.
  const slides = data.items.length === 3 ? [...data.items, ...data.items] : data.items;
  const settings = {
    arrows: true,
    dots: false,
    infinite: true,
    autoplay: false,
    autoplaySpeed: 3500,
    pauseOnHover: true,
    speed: 600,
    slidesToShow: 3,
    slidesToScroll: 1,
    prevArrow: <ExperienceArrow direction="prev" />,
    nextArrow: <ExperienceArrow direction="next" />,
    responsive: [
      { breakpoint: 992, settings: { slidesToShow: 2 } },
      { breakpoint: 768, settings: { slidesToShow: 1 } },
    ],
  };

  return (
    <section className="dynamic-team-work-section" aria-labelledby={titleId}>
      <div className="container">
        <div className="dynamic-team-work-heading text-center">
          <span className="main-title">{data.eyebrow}</span>
          <h2 className="heading" id={titleId}>{data.title}<br />{data.titleSecondLine}</h2>
        </div>
        <Slider {...settings} className="dynamic-team-work-slider">
          {slides.map((item, index) => (
            <div className="dynamic-team-work-slide" key={`${item.title}-${index}`}>
              <article className="dynamic-team-work-card">
                <img src={item.image} alt={item.imageAlt} width="468" height="340" loading="lazy" />
                <div className="dynamic-team-work-content">
                  <h3>{item.title}</h3>
                  <p>{item.description}</p>
                  
                  <p className="dynamic-team-work-metas">{item.skils}</p>
                  <p className="dynamic-team-work-meta">{item.details}</p>
                  <a className="dynamic-team-work-explore" href={item.buttonLink || data.buttonLink} aria-label={`Explore experience: ${item.title}`}>
                    {data.buttonText} <span aria-hidden="true">→</span>
                  </a>
                </div>
              </article>
            </div>
          ))}
        </Slider>
      </div>
    </section>
  );
}
